export const NewCourierPickup: string = 'new'